export default {
    setHealthCheckData: (state, action) => {
        state.data = action.payload;
    },
    clearHealthCheckFilters: (state) => {
        state.queryParams = { createdAt_min: null, createdAt_max: null };
    }
}; 